import { render, staticRenderFns } from "./commentAuditTableHead.vue?vue&type=template&id=2f572320&scoped=true&"
import script from "./commentAuditTableHead.vue?vue&type=script&lang=js&"
export * from "./commentAuditTableHead.vue?vue&type=script&lang=js&"
import style0 from "./commentAuditTableHead.vue?vue&type=style&index=0&lang=css&"
import style1 from "./commentAuditTableHead.vue?vue&type=style&index=1&id=2f572320&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f572320",
  null
  
)

export default component.exports